import { Image as ImageIcon, ListFilter, Loader2, MonitorPlay, Smartphone, Type, Zap } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabaseClient'; 
import { styles } from '../../styles'; 

export function ShortsPublisher() {
  const [videoUrl, setVideoUrl] = useState('');
  const [thumbUrl, setThumbUrl] = useState(''); 
  const [title, setTitle] = useState('');
  const [category, setCategory] = useState('ao_vivo');
  const [loading, setLoading] = useState(false);
  const [previewThumb, setPreviewThumb] = useState('');
 const [destino, setDestino] = useState('feed'); // 👈 Padronizado para 'feed' // 👈 Muda o padrão para algo exclusivo do app 

  const [thumbFile, setThumbFile] = useState<File | null>(null); // 👈 ADICIONE ESTA LINHA

  // 🖼️ LÓGICA DE PRÉVIA
  useEffect(() => {
    const extrairIdYoutube = (url: string) => {
      if (!url) return null;
      const ytRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/|youtube\.com\/shorts\/)([^"&?\/\s]{11})/;
      const match = url.match(ytRegex);
      return (match && match[1]) ? match[1] : null;
    };

    if (thumbUrl) {
      setPreviewThumb(thumbUrl); 
    } else {
      const id = extrairIdYoutube(videoUrl);
      if (id) setPreviewThumb(`https://img.youtube.com/vi/${id}/maxresdefault.jpg`);
      else setPreviewThumb('');
    }
  }, [thumbUrl, videoUrl]);

 const handlePublishShort = async () => {
    if (!title || !videoUrl) return alert("Título e Link do vídeo são obrigatórios!");
    
    setLoading(true);

    let categoriaLimpa = category.includes(':') ? category.split(':')[1] : category;
    categoriaLimpa = categoriaLimpa.replace(/_/g, ' ').toUpperCase();

    const extrairIdYoutube = (url: string) => {
      const ytRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/|youtube\.com\/shorts\/)([^"&?\/\s]{11})/;
      const match = url.match(ytRegex);
      return (match && match[1]) ? match[1] : null;
    };

    try {
      const embedId = extrairIdYoutube(videoUrl);
      let finalThumbUrl = '';

      // 1. Se houver upload de arquivo, joga para o Supabase Storage
      if (thumbFile) {
        const fileExt = thumbFile.name.split('.').pop();
        const fileName = `short_${Date.now()}_${Math.random().toString(36).substring(2)}.${fileExt}`;
        
        const { error: uploadError } = await supabase.storage
          .from('videos_feed')
          .upload(fileName, thumbFile);

        if (uploadError) {
          throw new Error("Erro no upload da imagem: " + uploadError.message);
        }

        const { data } = supabase.storage
          .from('videos_feed')
          .getPublicUrl(fileName);

        finalThumbUrl = data.publicUrl;
      } 
      // 2. Se digitou link manual
      else if (thumbUrl) {
        finalThumbUrl = thumbUrl;
      } 
      // 3. Fallback automático do YouTube
      else if (embedId) {
        finalThumbUrl = `https://img.youtube.com/vi/${embedId}/maxresdefault.jpg`;
      }

      const { error } = await supabase.from('videos').insert([{
        title: title,
        url: videoUrl,
        video_url: videoUrl,
        thumbnail: finalThumbUrl,
        embed_id: embedId,
        category: categoriaLimpa, 
        post_type: destino,
        is_short: false,
        likes_count: 0,
        comments_count: 0,
        views_count: 0,
        is_ad: false
      }]);

      if (error) throw error;

      alert("✅ Vídeo publicado com sucesso!");
      setTitle(''); setVideoUrl(''); setThumbUrl(''); setThumbFile(null);
    } catch (err: any) {
      alert("Erro ao publicar: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const extrairIdYoutubePlayer = (url: string) => {
    if (!url) return null;
    const ytRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/|youtube\.com\/shorts\/)([^"&?\/\s]{11})/;
    const match = url.match(ytRegex);
    return (match && match[1]) ? match[1] : null;
  };

  const youtubeId = extrairIdYoutubePlayer(videoUrl);

  return (
    <div>
      <style>{`
        .shorts-publisher-layout {
          display: grid;
          grid-template-columns: 1fr 400px;
          gap: 30px;
          width: 100%;
          box-sizing: border-box;
        }
        @media (max-width: 768px) {
          .shorts-publisher-layout {
            display: flex;
            flex-direction: column-reverse;
            gap: 15px;
          }
        }
      `}</style>

      <div className="shorts-publisher-layout">
        <div style={styles.formCard}>
          <h2 style={{ color: '#00ff00', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 10, fontSize: '18px' }}>
            <Zap size={22} /> Publicar Vídeo (16:9)
          </h2>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div style={styles.inputGroup}>
              <label style={styles.label}><MonitorPlay size={14}/> Link do YouTube</label>
              <input style={styles.input} value={videoUrl} onChange={e => setVideoUrl(e.target.value)} placeholder="Cole o link do vídeo..." />
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}><Type size={14}/> Título do Vídeo</label>
              <input style={styles.input} value={title} onChange={e => setTitle(e.target.value)} placeholder="Ex: Gameplay incrível..." />
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}><ImageIcon size={14}/> Capa do Vídeo (Upload ou Link)</label>
              <input 
                type="file" 
                accept="image/*" 
                onChange={e => setThumbFile(e.target.files?.[0] || null)} 
                style={{...styles.input, marginBottom: 5}} 
              />
              <input 
                style={styles.input} 
                value={thumbUrl} 
                onChange={e => setThumbUrl(e.target.value)} 
                placeholder="Ou cole o link da imagem..." 
              />
            </div>

           <div style={styles.inputGroup}>
              <label style={styles.label}><ListFilter size={14}/> Categoria do Vídeo</label>
              <select style={styles.input} value={category} onChange={e => setCategory(e.target.value)}>
                <option value="oculto">👁️ Invisível (Só Pesquisa)</option>
                
                <optgroup label="🔥 DESTAQUES E GERAL">
                  <option value="curiosidades">💡 Curiosidades</option>
                  <option value="novidades">🆕 Novidades</option>
                  <option value="viral">🔥 Em Alta</option>
                  <option value="noticias">📰 Notícias</option>
                  <option value="engracados">😂 Vídeos Engraçados</option>
                  <option value="anuncios">📢 Anúncios & Ofertas</option>
                </optgroup>

                <optgroup label="✨ DIVERSÃO & REVIEWS">
                  <option value="podcast">🎙️ Podcast</option>
                  <option value="unboxing">📦 Unboxing</option>
                </optgroup>

                <optgroup label="🎬 ENTRETENIMENTO">
                  <option value="filmes:acao">🎬 Cinema & Filmes</option>
                  <option value="games">🎮 Mundo Game</option>
                </optgroup>
              </select>
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}><Zap size={14}/> Destino do Vídeo</label>
              <select style={styles.input} value={destino} onChange={e => setDestino(e.target.value)}>
                <option value="app_exclusivo">📱 Exclusivo para o App (16:9)</option>
                <option value="feed">🏠 Home Principal (Comunidade Web)</option>
              </select>
            </div>

            <button onClick={handlePublishShort} disabled={loading} style={{...styles.btnPublish, backgroundColor: '#00ff00', color: '#000', width: '100%'}}>
              {loading ? <Loader2 className="animate-spin" /> : 'PUBLICAR VÍDEO'}
            </button>
          </div>
        </div>

        {/* PRÉVIA HORIZONTAL 16:9 COM PLAYER INTERATIVO */}
        <aside style={{ backgroundColor: '#111', padding: 20, borderRadius: 20, border: '1px solid #222', height: 'fit-content' }}>
          <h3 style={{ color: '#fff', marginBottom: 20, fontSize: 16 }}>PRÉVIA (16:9)</h3>
          
          <div style={{ 
            width: '100%', 
            paddingTop: '56.25%', 
            backgroundColor: '#000', 
            borderRadius: 10, 
            overflow: 'hidden',
            position: 'relative'
          }}>
            {youtubeId ? (
              <iframe
                src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1`}
                title="Player Preview"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            ) : previewThumb ? (
              <img 
                src={previewThumb} 
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }} 
                alt="Preview" 
              />
            ) : (
              <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <MonitorPlay color="#333" size={50} />
              </div>
            )}
          </div>
          <p style={{ color: '#fff', marginTop: 15, fontWeight: 'bold', fontSize: '13px', wordBreak: 'break-word' }}>{title || 'Título do Vídeo'}</p>
        </aside>
      </div>
    </div>
  );
}